export default __webpack_public_path__ + "static/media/quavo.52d9652a.png";